import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  attachmentsStep,
  closeStep,
  headerActionsStep,
  metadataStep,
  revisionsStep,
  workflowStep,
} from './steps';

export const SUBMITTALS_DETAIL_TOUR_ID = 'submittals.detail';

registerTour({
  id: SUBMITTALS_DETAIL_TOUR_ID,
  name: 'Submittal',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.SUBMITTALS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Submittal details',
      body:
        'Here\u2019s everything tied to this submittal — its workflow, ' +
        'attachments, revisions, and the close-out flow.',
    },
    headerActionsStep,
    metadataStep,
    workflowStep,
    closeStep,
    attachmentsStep,
    revisionsStep,
  ],
});
